import { SVGProps } from 'react';

function Waiting(props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.4615 0.5625H5.53846C2.47965 0.5625 0 2.91632 0 5.81989V18.0871C0 20.9907 2.47965 23.3445 5.53846 23.3445H18.4615C21.5203 23.3445 24 20.9907 24 18.0871V5.81989C24 2.91632 21.5203 0.5625 18.4615 0.5625Z"
        fill="#FFEAD6"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 18.5981C15.866 18.5981 19 15.6231 19 11.9533C19 8.28355 15.866 5.30859 12 5.30859C8.13401 5.30859 5 8.28355 5 11.9533C5 15.6231 8.13401 18.5981 12 18.5981Z"
        stroke="#F5963D"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 11.9532V9.58008"
        stroke="#F5963D"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 11.9531L15.1247 14.9198"
        stroke="#F5963D"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

Waiting.defaultProps = {
  role: 'graphics-document',
};

export default Waiting;
